<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome {
  padding-left: 2px;
}
.emtity-icon {
    height: 160px;
    width: 290px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    overflow: hidden;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>Sponsors
         <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows  + ")": ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec">
        <span class="ml-3 text-default h3"
          >Total Sponsors: {{ sponsorData.length }}</span
        >
        <span class="ml-3 text-success h3"
          >Published: {{ sponsorDataObj.published }}</span
        >
        <span class="ml-3 text-primary h3"
          >Categories: {{ sponsorDataObj.Categories }}</span
        >
      </div>
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->



    <div
      class="vx-card p-6 blank-attendee" v-show="sponsorData.length < 1"
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <img src="../../assets/images/blank-page-images/sponsors.png"/>
          <!--<feather-icon class="" icon="UsersIcon" />-->
        </div>
        <div class="entity-create-desc">
          <h2>Create an Sponsor</h2>
          <p>Here you can add sponsors and group them under categories such as Gold/Silver. They will be displayed as per your preferred order in the Sponsor screen of the events platform.</p>
          <div class="entity-setup-buttons">
            
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/sponsor/add')"
              >ADD NEW SPONSOR</vs-button
            >
            
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card p-6" v-show="sponsorData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ sponsorData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : sponsorData.length }} of {{ sponsorData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->
        
        <vs-button class="mr-4" type="filled" color="rgb(76, 139, 246)" v-on:click="addRecord ()">Create Sponsor</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>InActive</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="OpenSponserExportModal">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Sponser Reports</span>
              </span>
            </vs-dropdown-item>

            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button color="primary" type="border" class="ml-3" @click="popupActive=true">Import</vs-button>
        <vs-popup class="holamundo" title="Import Sponsor" :active.sync="popupActive">
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Sponsor.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
              >Download</a>
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="sponsor_file"
                  accept=".csv,.xlsx,.xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="UploadSponsor">Upload</vs-button>
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="fetch_sponsorCategory"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>
        <vs-popup
          class="holamundo"
          title="Please drag and drop to set category priority"
          :active.sync="popupActive2"
        >
          <draggable
            :list="CategoryList"
            :group="{name:'tags',pull: 'clone', put: false }"
            class="p-2 cursor-move menu-dragbox"
          >
            <vs-list-item
              v-for="(listItem, index) in CategoryList"
              :key="index"
              :title="listItem.CategoryName"
            >
              <vs-input
                :placeholder="listItem.CategoryName"
                :class="listItem.CategoryID==TextBoxShowingId ? 'show' : 'hidden'"
                v-model="listItem.CategoryName"
              />
              <div class="editbox-menu">
                <!-- <input
                  type="color"
                  :class="listItem.CategoryID==TextBoxShowingId ? 'show' : 'hidden'"
                  v-model="listItem.CategoryColor"
                  @change="listItem.CategoryColor"
                />-->
              </div>
              <div class="menu-editwrap">
                <span
                  :class="listItem.CategoryID==TextBoxShowingId ? 'show' : 'hidden'"
                  @click="hideTextBox(listItem.CategoryID,listItem.CategoryName)"
                >Save</span>
                <span class="menu-delete ml-4" @click="showTextBox(listItem.CategoryID)">
                  <img src="../../assets/images/icon-edit.png" />
                </span>
                <span class="menu-delete ml-4" @click="deleteSelected(listItem.CategoryID)">
                  <img src="../../assets/images/delete.svg" width="20px" />
                </span>
                <!-- <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.CategoryName" /> -->
                <!-- <vs-button
                  :class="listItem.CategoryID==TextBoxShowingId ? 'show' : 'hidden' + ' ml-3'"
                  color="primary"
                  type="filled"
                  @click="hideTextBox(listItem.CategoryID,listItem.CategoryName)"
                >Save</vs-button>-->
              </div>
            </vs-list-item>
          </draggable>
          <br />
          <vs-button  color="rgb(76, 139, 246)" type="filled" @click="savePriority">Save Priority</vs-button>
        </vs-popup>
      </div>

      
      <vs-popup
        class="holamundo"
        title="Export Sponser Report"
        :active.sync="popupActiveSponserExport"
      >
        <div class="import-attendee-wrapper">
          <div class="template-download">
            <h4 id="modalSponserSelected">Sponser Selected : 0</h4>
            <br />
            <hr />
          </div>
          <br />
          <div class="upload-file mt-5">
            <vs-button
              color="rgb(76, 139, 246)" type="filled"
              class="sub-btn"
              v-on:click="fetchSponserVisitorList()"
              >Sponser Visits</vs-button
            >&nbsp;
          </div>
        </div>
      </vs-popup>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="sponsorData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import draggable from "vuedraggable";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import ls from "@/common/localStorage";
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
//console.log(db);

export default {
  components: {
    draggable,
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
  },
  data() {
    return {
      popupActiveSponserExport: false,
      sponserExportList: [],
      gridSelectedRows: 0,
      CategoryColor: "",
      TextBoxShowingId: -1,
      CategoryList: [],
      pageLoaded: false,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      searchQuery: "",

      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 300,
          cellRendererFramework: "CellRendererLink",
          pinned: "left",
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 200,
        },
        {
          headerName: "Category",
          //field: "Phone",
          filter: true,
          width: 140,
          cellRenderer: (data) => {
               return data.value && data.value.CategoryName ? data.value.CategoryName : 'NA';
          },
        },
        //{
        //  headerName: 'Created Date',
        //  field: 'CreatedDate',
        //  cellRenderer: (data) => {
        //       //return data.value.seconds ? this.GetDateTimeFromSeconds(data.value.seconds) : '';
        //       return data.value ? this.GetDateTimeFromSeconds(data.value) : '';
        //  },
        //  filter: true,
        //  width: 180
        //},
        {
          headerName: "Booth #",
          field: "BoothNo",
          filter: true,
          width: 120,
        },
        // {
        //   headerName: 'Verified',
        //   field: 'is_verified',
        //   filter: true,
        //   width: 125,
        //   cellRendererFramework: 'CellRendererVerified',
        //   cellClass: 'text-center'
        // },
        {
          headerName: "Website",
          field: "Website",
          filter: true,
          width: 250,
        },
        {
          headerName: "Round Table",
          field: "MappedRoundTables",
          filter: true,
          width: 250,
          cellRenderer: (data) => {
               return data.value && data.value.length ? 'Yes' : 'No';
          },
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.SponsorId };
          },
        },
        {
          headerName: "Status",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return { id: params.data.SponsorId };
          },
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    sponsorData() {
      return this.$store.state.sponsorManagement.sponsors;
    },
    sponsorDataObj(){
      let sponsorDataObj = {
        published: 0,
        Categories: 0
      }
      this.$store.state.sponsorManagement.sponsors.forEach(item=>{
        sponsorDataObj.published += item.IsPublished ? 1 : 0;
        sponsorDataObj.Categories += item.Category ? 1 : 0;
      })
      return sponsorDataObj;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    fetch_sponsorCategory() {
      this.$store
        .dispatch("sponsorManagement/fetchSponsorCategoryDropdown")
        .then((res) => {
          this.CategoryList = res;
          this.popupActive2 = true;
          console.log(res);
        });
    },
    showTextBox(id) {
      this.TextBoxShowingId = id;
    },
    hideTextBox(id, CategoryName) {
      debugger;
      console.log("CategoryName:- " + CategoryName);
      this.UpdateSingleCategory(id, CategoryName);
      this.TextBoxShowingId = -1;
    },
    deleteSelected: function (id) {
      debugger;
      console.log("CategoryId:- " + id);
      this.$vs.loading();
      this.$store
        .dispatch("sponsorManagement/DeleteSponsorCategory", {
          CategoryID: id,
        })
        .then((res) => {
          //alert(res.message)

          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Sponsor Category",
            text: res.message,
          });

          this.$vs.loading.close();
          if (res.status == 200) {
            this.$vs.loading.close();
            this.popupActive2 = false;
            this.fetch_sponsorCategory();
          }
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
        });
      this.popupActive2 = false;
    },
    UpdateSingleCategory: function (id, CategoryName) {
      debugger;
      console.log("CategoryId:- " + id);
      this.$vs.loading();
      this.$store
        .dispatch("sponsorManagement/UpdateSponsorCategoryFiealds", {
          CategoryID: id,
          CategoryName: CategoryName,
          CategoryColor: "",
        })
        .then((res) => {
          //alert(res.message)
          //if (i + 1 == lngth) {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Sponsor Category",
            text: res.message,
          });
          // }
          this.$vs.loading.close();
          if (res.status == 200) {
            this.popupActive2 = false;
            this.fetch_sponsorCategory();
          }
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
        });
    },

    savePriority: function () {
      console.log(this.CategoryList.length);
      for (var i = 0; i < this.CategoryList.length; i++) {
        // console.log(i + "" + this.CategoryList[i].CategoryName);
        var lngth = this.CategoryList.length;
        this.$vs.loading();
        this.$store
          .dispatch("sponsorManagement/UpdateSponsorCategory", {
            CategoryID: this.CategoryList[i].CategoryID,
            CategoryPriority: i + 1,
            LastModifiedDate: new Date(),
          })
          .then((res) => {
            //alert(res.message)
            //if (i + 1 == lngth) {
            // this.$vs.notify({
            //   color: "success",
            //   position: "top-center",
            //   title: "Sponsor Category",
            //   text: res.message,
            // });
            // }
            this.$vs.loading.close();
            if (res.status == 200) {
              // this.CategoryName = "";
              // this.popupCategoryActive = false;
              // this.fetch_sponsorCategory();
            }
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
          });
      }
      this.$vs.notify({
        color: "success",
        position: "top-center",
        title: "Sponsor Category",
        text: "Record Updated",
      });
      this.popupActive2 = false;
    },
    addRecord() {
      this.$router.push(`/event/sponsor/add`).catch(() => {});
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("sponsorManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("sponsorManagement/fetchSponsors");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    UploadSponsor: function () {
      var files = document.getElementById("sponsor_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "sponsor");
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    OpenSponserExportModal() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download Sponser Reports",
            text: "Please Download 10 report at a time. ",
            acceptText: "OK",
          });
        } else {
          this.popupActiveSponserExport = true;
          document.getElementById("modalSponserSelected").innerText =
            "Sponser(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Sponser Reports",
          text: "Please select atleast one Sponser to download. ",
          acceptText: "OK",
        });
      }
    },
    fetchSponserVisitorList() {
      this.$vs.loading();
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      selectedRows.map((row) => {
        this.$store
          .dispatch(
            "sponsorManagement/fetchSponserVisitorReport",
            row.SponsorId
          )
          .then((res) => {
            this.sponserExportList = res.data;
            this.$vs.loading.close();
            this.getSponserVisits(row.Name);
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
          });
      });
    },
        getSponserVisits(sponserName) {
      var datarow = [];
      var timeZone = [];
      var sponserData = [];

      timeZone.push("Report Exported In ");
      var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
      timeZone.push('"' + timezone + " Time Zone" + '"');

      sponserData.push("Sponser Name");
      var sponser = sponserName;
      sponserData.push('"' + sponser + '"');

      datarow.push("Name");
      datarow.push("Email");
      datarow.push("Time");
      var userLoginData = [];
      userLoginData.push(datarow);

      var TimeZoneHeader = [];
      TimeZoneHeader.push(timeZone);

      var SponserHeader = [];
      SponserHeader.push(sponserData);

      this.sponserExportList.map((row1) => {
        datarow = [];
        var name = row1.userName == undefined ? "" : row1.userName;
        datarow.push('"' + name.trim() + '"');
        var email = row1.userEmail == undefined ? "" : row1.userEmail;
        datarow.push('"' + email.trim() + '"');
        var date = row1.viewDtm == undefined ? "" : '"' + row1.viewDtm + '"';
        datarow.push(date);

        userLoginData.push(datarow);
      });
      let csvContent = "data:text/csv;charset=utf-8,";
      var dt = new Date().toISOString().slice(0, 10);
      TimeZoneHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      SponserHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      userLoginData.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var filename = "SponserVisitReport" + "_" + sponserName + "_" + dt + ".csv";
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      //link.setAttribute("id", "Participance_RT_" + row.TableId);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleSponsorManagement.isRegistered) {
      this.$store.registerModule("sponsorManagement", moduleSponsorManagement);
      moduleSponsorManagement.isRegistered = true;
    }
     this.$vs.loading();
    this.$store.dispatch("sponsorManagement/fetchSponsors").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      })
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>